import React from 'react'
import { EmojiPicker as StreamEmojiPicker } from 'stream-chat-react/emojis'
import MessagingEmojiPickerIcon from './messaging-emoji-picker-icon'

const MessagingEmojiPicker = props => (
  <StreamEmojiPicker
    ButtonIconComponent={MessagingEmojiPickerIcon}
    {...props}
  />
)

export default MessagingEmojiPicker
